import { REVENUE_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { RevenueShareInterface } from '../type/revenueType';

class RevenueShareService {
  constructor(private readonly apiService: ApiService<RevenueShareInterface>) {}

  public async fetchShare(
    queryParams?: Record<string, string>
  ): Promise<FetchResult<RevenueShareInterface>> {
    const response = await this.apiService.fetchBySubPath<RevenueShareInterface>(
      'share/',
      new URLSearchParams(queryParams)
    );
    return response;
  }
}

export const revenueShareService = new RevenueShareService(new ApiService(REVENUE_API_PATH));
